module.exports = __webpack_public_path__ + "media/components/assets/images/live_on-bc50fdcae3036ec50720be8a189476b1.svg";